<template>
  <div>
    <v-form ref="form">
      <v-row class="pa-5" justify="space-around">
        <v-col cols="12" md="5">
          <h3 class="font-weight-bold">{{ $t( isEdit ? 'buttons:edit-specific' : 'buttons:add-specific', { specific: $t('common:documentation')}) }}</h3>
          <DragAndDropFile
              ref="dragAndDrop"
              @fileChange="uploadAsUrl($event)"
              custom-height="75vh"
              :view-only="hideButton"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12" md="5">
              <!-- Upload Section -->
              <h4 class="primary--text font-weight-medium">{{ $t('buttons:upload') }}</h4>
              <v-text-field
                  v-model="documentation.name"
                  outlined
                  :label="$t('common:document-name')"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  tabindex="80"
              />

              <v-select
                  v-model="documentation.type"
                  outlined
                  :label="$t('book/facility:facility.dashboard.information.docus.type')"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="restTypes"
                  item-text="translatedName"
                  item-value="name"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  tabindex="81"
              >
              </v-select>
            </v-col>
            <v-col class="d-none d-md-block" md="1"></v-col>
            <v-col cols="12" md="5">
              <!-- Validity Section -->
              <h4 class="primary--text font-weight-medium">{{ $t('book/facility:facility.dashboard.information.docus.date') }}</h4>

              <DateField
                  ref="start"
                  @update="(v) => (documentation.start = v)"
                  :isClearable="true"
                  :label="$t('common:valid-from')"
                  tabindex="82"
                  :key="dateStartKey"
              />

              <DateField
                  ref="end"
                  @update="(v) => (documentation.end = v)"
                  :isClearable="true"
                  :label="$t('common:valid-until')"
                  tabindex="83"
                  :key="dateEndKey"
              />
            </v-col>
            <v-col cols="12">
              <FacilityList v-if="isGlobal"
                  ref="facilityList"
                  @facilitiesChange="v => facilityIds = v"
                  @companyChange="v => documentation.globalCompany = v"
              />
            </v-col>
          </v-row>

          <v-row v-if="!hideButton">
            <BaseButton
                color="primary"
                :btnText="$t(documentation.id ? 'buttons:edit-specific' : 'buttons:add-specific', { specific: $t('common:documentation') })"
                @clickedButton="uploadFacilityDocumentation()"
            />

            <DirtyConfirmButtonDialog
                ref="dirtyDialog"
                :btn-text="$t('buttons:cancel')"
                color="grey"
                :dialog-title="$t('dialog:dirty-save-btn-title')"
                :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                :button1-text="$t('dialog:dirty-save-btn-1-text')"
                :button2-text="$t('dialog:dirty-save-btn-2-text')"
                @clickedButton="() => { clearForm(); $emit('dialogClosed');}"
                :dataToWatch="documentation"
                hideOverlay
            />
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog.vue";
import FacilityList from "@/modules/book/views/global-documentation/contract/form/FacilityList.vue";
import BaseButton from "@/modules/core/components/Base/BaseButton.vue";
import DateField from "@/modules/core/components/DateField.vue";
import DragAndDropFile from "@/modules/core/components/DragAndDropFile.vue";
import FacilityDocumentation from "@/modules/book/data/facility-documentation";
import Utils from "@/modules/core/services/utils";
import InfoService from "@/modules/core/services/info-service";
import DocumentationService from "@/modules/core/services/documentation-service";
import GlobalDocumentationService from "@/modules/book/services/global-documentation-service";
import {ruleRequired} from "@/modules/core/services/rules";
export default {
  name: 'FacilityDocuForm',
  components: {
    DateField,
    DragAndDropFile,
    DirtyConfirmButtonDialog,
    BaseButton,
    FacilityList
  },
  props: {
    isGlobal: Boolean,
    hideButton: Boolean
  },
  data() {
    return {
      file: null,
      documentation: new FacilityDocumentation(),
      restTypes: [],
      tableOptions: [],
      tableSearch: [],
      dragover: false,
      dateEndKey: 0,
      dateStartKey: 1,
      facilityIds: [],
      isEdit: false,
      facilityId: null
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      });
    }
  },
  methods: {
    ruleRequired,
    loadEnums() {
      InfoService.readEnum("documentation/facility",
          (resp) => {
            for(var i = 0; i < resp.data.length; i++) {
              this.restTypes.push({name: resp.data[i]})
            }
            this.translateAndSortTypes()
            if (!this.hideButton) {
              this.$refs.dirtyDialog.startWatch();
            }
          },
          (error) => {
            this.$logger.error("Error at InfoService.readEnum: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:facility.dashboard.information.docus.document-types')}))
          }
      )
    },
    clearForm() {
      this.documentation = new FacilityDocumentation();
      this.$refs.form.reset();
      this.dateStartKey++;
      this.dateEndKey--;
      this.$refs.start.resetData();
      this.$refs.end.resetData();
      this.$refs.dragAndDrop.clear();
      this.facilityIds = [];
      this.facilityId = null;
      this.isEdit = false;
    },
    addDocu(options, search) {
      this.tableOptions = options;
      this.tableSearch = search;
      this.isEdit = false;
      if (this.isGlobal) this.$refs.facilityList.clear();
    },
    editGlobalDocumentation(facilityBuildList, item, options, search) {
      this.tableOptions = options;
      this.tableSearch = search;
      this.documentation = item;
      this.isEdit = true;

      if (item.startDate) {
        this.$refs.start.parseDTO(item.startDate);
      }
      if (item.endDate) {
        this.$refs.end.parseDTO(item.endDate);
      }

      DocumentationService.getDocByTypeAndId(item.id, item.fileType, 'GLOBAL', item.customer,
          (url, file) => {
            let docuToParse = {
              fileType: item.fileType,
              src: url
            }
            this.$refs.dragAndDrop.setPreviewSrc(docuToParse, file);
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:settings')}));
          }
      );

      if (item.global && item.customer) {
        item.globalCompany = item.customer
      }
      this.$refs.facilityList.setSelectedItems(facilityBuildList, item);
    },
    uploadGlobalDocumentation() {
      if (this.documentation.start) this.documentation.startDate = this.documentation.start;
      if (this.documentation.end) this.documentation.endDate = this.documentation.end;

      GlobalDocumentationService.saveOrUpdateGlobalDocumentation(
          this.documentation,
          this.file,
          this.facilityIds,
          () => {
            Utils.showSuccessSnackbar(this.$t(this.isEdit ? 'snackbar:edit-success' : 'snackbar:upload-success', {name: this.$t('common:document')}));
            this.clearForm();
            this.$emit('dialogClosed');
            this.$emit("updateDocuData");
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:upload-failure', {name: this.$t('common:document')}));
          }
      );
    },
    uploadAsUrl(file) {
      this.file = null;
      if (!file) return;

      this.$refs.dragAndDrop.uploadAsUrl(file);
      this.file = file;
    },
    uploadFacilityDocumentation() {
      // because `||` is a short-circuits operator, when some condition return true the rests operators don't execute,
      // but we need to check at the same time all conditions to highlight not filled out fields.
      if (this.isGlobal) {
        this.isGlobal && !this.$refs.facilityList.isMandatoryFilledOut();
      }
      this.$refs.dragAndDrop.isMandatoryFilledOut()
      if (!this.$refs.form.validate()
          || this.isGlobal && !this.$refs.facilityList.isMandatoryFilledOut()
          || !this.$refs.dragAndDrop.isMandatoryFilledOut()
      ) {
        // TODO scroll to specific form field which doesnt require the rules
        window.scrollTo(0, 0);
        return;
      }

      if (this.documentation.start == null) {
        this.documentation.start = '';
      }
      if (this.documentation.end == null) {
        this.documentation.end = '';
      }

      if (this.isGlobal) {
        this.uploadGlobalDocumentation();
        return;
      }

      let facilityId = this.facilityId ? this.facilityId : this.$route.params.id;
      DocumentationService.postFacilityDocumentationToAPI(facilityId, this.file, this.documentation,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:upload-success', {name: this.$t('common:document')}));
            this.clearForm();
            this.$emit('dialogClosed');
            this.$emit("updateDocuData", this.tableOptions, this.tableSearch);
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:upload-failure', {name: this.$t('common:document')}))
            this.clearForm();
            this.$emit('dialogClosed');
          })
    },
    translateAndSortTypes() {
      for(var j = 0; j < this.restTypes.length; j++) {
        this.restTypes[j].translatedName = this.$t('enums:facility-documentation-types.' + this.restTypes[j].name);
      }

      this.restTypes.sort((a, b) => {
        if(a.translatedName < b.translatedName) {
          return -1;
        }

        if(a.translatedName > b.translatedName) {
          return 1;
        }

        return 0;
      })
    },
    setFacilityId(facilityId) {
      this.facilityId = facilityId;
    }
  }

}
</script>